export default function deriveActivePlaylist(playlists, user) {
    // ensure we always handle the single-playlist scenario consistently
    return playlists?.length === 1
        ? playlists[0]
        : (playlists || []).find(playlist => playlist.localePackId === user.active_playlist_locale_pack_id);
}
